// extracted by mini-css-extract-plugin
export var quantityInput = "_gy-0";